import * as React from "react";
import Box from "@mui/material/Box";
import ProjectRightMenuBar from "../components/ProjectRightMenuBar";
import ProjectHeader from "../components/ProjectHeader";
import Api, {APIs} from "../../../Api";
import useQuery from "../../base/utils/UseQuery";
import {useSelector} from "react-redux";

import {useLocation} from "react-router-dom";
import ProjectInfoContainer from "./ProjectInfoContainer";
import ProjectPictures from "../components/ProjectPictures";
import ProjectGanttChart from "../components/GanttChart/ProjectGanttChart";

interface IProps {
    pid?: string
    showRightMenuBar?: boolean
}

const ProjectContents = (props: IProps) => {
    const [projectInfo, setProjectInfo] = React.useState<any>(null);
    const contentDivHeight = useSelector((state: any) => state.base.contentDivHeight);
    const [contentHeight, setContentHeight] = React.useState<number>(contentDivHeight);
    const query = useQuery();
    const pid: number = parseInt(props.pid ?? query.get("id") ?? "-1", 10);
    const showRightMenuBar = props.showRightMenuBar !== undefined ? props.showRightMenuBar : true;


    const location = useLocation()
    React.useEffect(() => {
        Api.get(APIs.MoPD_PROJECT_BASIC_INFO, {pid: pid}).then((payload) => {
            if (payload) {
                setProjectInfo(payload)
            }
        });
    }, [])
    const ref = React.useRef<any>();
    React.useLayoutEffect(() => {
        if (ref.current && ref.current.clientHeight) {
            const headerHeight = ref.current.clientHeight;
            setContentHeight(contentDivHeight - headerHeight)
        }
    });
    const RenderContent = (location: any, pid: number) => {
        if (location && location.pathname === "/project_physical_progress") {
            return <ProjectGanttChart key="projectGanttChart" pId={pid}/>;
        } else if (location && location.pathname === "/photo_gallery") {
            return <ProjectPictures key="projectPictures" pid={pid}/>;
        } else {
            return <ProjectInfoContainer key="projectInfoStepper" pid={pid.toString()}/>;
        }
    };

    return (
        <React.Fragment>
            <ProjectHeader ref={ref} title={projectInfo?.title}
                           signing_date={projectInfo?.signing_date}
                           closing_date={projectInfo?.closing_date}/>
            <Box sx={{
                display: 'flex', flexDirection: 'row',
            }}>
                <Box sx={{flex: 2, overflow: "auto"}}>
                    <Box sx={{
                        display: "flex",
                        flex: 1,
                        p: 0,
                        width: "100%",
                        height: contentHeight,
                        boxSizing: "border-box",
                        overflow: "auto"
                    }}>
                        {RenderContent(location, pid)}
                    </Box>
                </Box>
                {showRightMenuBar && <Box sx={{display: "flex"}}>
                    <ProjectRightMenuBar key={"project-right-menu"}/>
                </Box>}
            </Box>
        </React.Fragment>
    )
}

export default ProjectContents
